module.exports = __webpack_public_path__ + "media/2.1696b8bc.mp3";